export interface LoadingScreen {
  element: HTMLElement;
  setVisible(visible: boolean): void;
  setMessage(message: string): void;
}

export function createLoadingScreen(): LoadingScreen {
  const element = document.createElement("div");
  element.className = "loading-screen";
  element.hidden = true;
  element.setAttribute("role", "status");
  element.setAttribute("aria-live", "polite");

  const spinner = document.createElement("span");
  spinner.className = "loading-screen__spinner";
  spinner.setAttribute("aria-hidden", "true");

  const message = document.createElement("span");
  message.className = "loading-screen__message";
  message.textContent = "A preparar experiência…";

  element.append(spinner, message);

  return {
    element,
    setVisible(visible: boolean): void {
      element.hidden = !visible;
    },
    setMessage(nextMessage: string): void {
      message.textContent = nextMessage;
    },
  };
}
